import React, { useEffect, useState } from 'react'
import { getAllOrByIdOrDownloadBillingApi, approveOrRejectOrSubmitBillingByIdApi, sendBillingToSubcontractorApi } from '../../utils/ApiEndpointFunctions'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useUserContext } from '../../context/userContext';
import ConfirmationModal from '../../components/modal/ConfirmationModal';
import toast from 'react-hot-toast';
import Spinwheel from '../../components/common/Spinwheel';
import { formatPrice, getLocalizationStatus, getRoundOff } from '../../utils/HelperFuncitons';
import moment from 'moment';
import StatusModal from '../../components/modal/StatusModal';
import DprItemComp from '../../components/common/DpritemComp';
import ActivityHistory from '../../components/common/ActivityHistory';


function ViewBilling({isPreview,previewBack}) {
  const params = useParams();
  const { userDetails,langPreference } = useUserContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = params;
  let previewId = searchParams?.get('preview')
  const [details, setDetails] = useState();
  const navigate = useNavigate();
  const confirmModalId = "conFirmModalID"
  const statusModalId = "statusModal"
  const submitConfirmModal = "submitConfirmModal1"
  const [updatedStatus,setUpdatedStatus] = useState(null)
  const [confirmationMsg, setConfirmationMsg] = useState('')
  const [navigationRoute, setNavigationRoute] = useState("")
  const [download,setDownload] = useState(false)
  const [selectItemId,setSelectItemId]= useState({id:null,load:false})
  const [sumitting,setSubmitting] = useState(false)
  const [sending,setSending] = useState(false)
  const location = useLocation();
  

  const getDetailsById = async (id) => {
    try{
      const res = await getAllOrByIdOrDownloadBillingApi("","","","",id)
      if (res.status === 200) {
        const {billing} = res.data?.data
        if(billing[0]){
           setDetails(billing[0]);
        }
        setSelectItemId({id:null,load:false})
      }
    }catch(err){
      console.log(err)
      if (err.response && err.response.data) {
        toast.error(err.response.data.message)
      } else {
        toast.error("Something went wrong")
      }
    }
  }
  

  const handleConfirmation = async () => {
    try {
      const res = await approveOrRejectOrSubmitBillingByIdApi({ id: previewId || id,status:updatedStatus })
      if (res.status === 200) {
        document.getElementById(confirmModalId).click()
        setConfirmationMsg(res?.data?.message || `BL ${details?.dprNumber || ""} is successfully ${updatedStatus}.`)
        document.getElementById("statusModalBtn").click()
        setNavigationRoute(searchParams?.get('tab') ? `/billing?tab=${searchParams?.get("tab")}&type=billing` : (isPreview ? `/billing/view/${previewId}` : ''))
        if(!previewId){
           getDetailsById(id)
        }
      }
    } catch (error) {
      console.log(error)
      toast.error("something went wrong");
    }
  }


  const handleCloseStatusModal = () => {
    if(navigationRoute){
      navigate(navigationRoute)
    }
  }



  useEffect(() => {
    if (id || previewId) {
      getDetailsById(id || previewId)
    }else{
      window.history.back()
    }
  }, [previewId])

  const getDownloadDetails =async()=>{
    try {
      setDownload(true)
      const response = await getAllOrByIdOrDownloadBillingApi("","","","",previewId || id,true)
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', details?.billNumber ? `${details.billNumber}.xlsx` :'Billing.xlsx'); // or any other filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownload(false)
      toast.success("Successfully downloaded");
    } catch (error) {
      setDownload(false)
      toast.error("Failed to download");
    }
  }

  const sendToSubcontractor = async () => {
    try {
      setSending(true)
      const res = await sendBillingToSubcontractorApi(previewId || id)
      toast.success(res?.data?.message || "Billing sent successfully")
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send billing")
    } finally {
      setSending(false)
    }
  }

  const openBillingVoucher = () => {
    if (details?.voucherId) {
      navigate(`/voucher/add/${details.voucherId}`)
      return
    }
    navigate("/voucher/add", {
      state: {
        billingId: details?._id,
        number: details?.billNumber,
        name: details?.subcontractor?.name || details?.seqNo?.[0]?.vendor?.name || "",
        amount: details?.voucherAmount || "",
        vendorType: "subcontractor",
        remarks: `Billing ${details?.billNumber || ""} / RA ${details?.raBillNo || ""}`,
      },
    })
  }

const getConfirmationMsg = ()=>{
   let msg = ""
   console.log("updatedStatus",updatedStatus);
   
   if(updatedStatus=="approved"){
      msg = langPreference?.approve_confirmation || "Are you sure you want to approve ?"
   }else if(updatedStatus=="rejected"){
      msg = langPreference?.confirm_reject || "Are you sure you want to reject ?"
   }else if(updatedStatus=="submitted"){
      msg = langPreference?.submit_confirmation || "Are you sure you want to submit ?"
   }else{
      msg = <>Are you sure you want to <br /> {updatedStatus} ?</>
   }

   return msg
}

const getTextBreak=(str)=>{
  return str?.slice(0,20) + (str?.length>25 ? (" ... " +str?.slice((str?.length-15),str?.length)) : "")
}



  return (
    <>
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
           {!isPreview && <div className="back"><span onClick={() => navigate(location?.state?.path ? location?.state?.path : -1, { state: { ...location?.state } })} className="back cursor-pointer" ><i className="bi bi-chevron-left"></i> {langPreference.back || "Back"}</span></div> }
            <div className="main-content">
              
              <div className="d-flex row justify-content-center">
                <div className="col-lg-10 col-md-12 col-xxl-11 card p-5 my-3">
                  <div>
                  <div className='fw-bold'>
                      {langPreference.preview || "Preview"}
                    </div>
                    <div className='fs-3 fw-normal'>
                      {langPreference.site_details || "Site details"}
                    </div>
                    <div className="row row-cols-2">
                      <div className="">{langPreference.site_name || "Site name"}</div>
                      <div>{details?.site?.[0]?.name}</div>
                    </div>
                    <div className="row row-cols-2">
                      <div className="">{langPreference.company || "Company"}</div>
                      <div>{details?.site?.[0]?.company?.name}</div>
                    </div>
                    <hr />
                  </div>
                  <div className="d-flex justify-content-between">
                    
                    <div className="">
                      <h1 className='text-capitalize'>
                      {details?.subcontractor?.name || details?.vendor?.name || details?.seqNo?.[0]?.vendor?.name || ""}

                      </h1>
                    </div>
                   
                  </div>
                  <div className="row row-cols-2 mt-3">
                    <div className="fw-bold">{langPreference?.billing_number || "Billing Number"}</div>
                    <div>{details?.billNumber}</div>
                  </div>
                  <div className="row row-cols-2 mt-3">
                    <div className="fw-bold">{langPreference?.bill_date || "Bill Date"}</div>
                    <div>{moment(details?.billDate).format("DD/MM/YYYY")}</div>
                  </div>
                  <div className="row row-cols-2 mt-3">
                    <div className="fw-bold">{langPreference?.ra_bill_no || "RA Bill No"}</div>
                    <div>{details?.raBillNo}</div>
                  </div>
            
                  <div className="row row-cols-2 mt-3">
                    <div className="fw-bold">{langPreference.status || "Status"}</div>
                    <div className='text-capitalize'>{getLocalizationStatus(langPreference,details?.status)}</div>
                  </div>
                  
                  <hr/>
                  <h3>
                    {langPreference.items || "Items"} ({details?.seqNo?.length || 0})
                  </h3>
                  <div className='w-100 mt-1'>
                        <div className="">
                          <table className="table table-bordered mt-4" style={{position:'relative'}}>
                            <thead  style={{position:'sticky', top: '75px', backgroundColor: '#ffffff'}}>
                              <tr>
                              {/* <th>{langPreference?.dpr_date || "DPR Date"}</th> */}
                                  <th className='col-1'>{langPreference?.s_no || "S.No."}</th>
                                    <th className='col-3'>{langPreference?.item_description || "Item Description"}</th>
                                   <th className='col-1'><span className='text-end align-items-end d-flex justify-content-end'>{langPreference?.no_ || "No"}</span></th>
                                    <th className='col-1'><span className='text-end align-items-end d-flex justify-content-end'>{langPreference?.no_ || "No"}</span></th>
                                    <th className='col-1'><span className='text-end align-items-end d-flex justify-content-end'>{langPreference?.length || "L"}</span></th>
                                    <th className='col-1'><span className='text-end align-items-end d-flex justify-content-end'>{langPreference?.breadth || "B"}</span></th>
                                    <th className='col-1'><span className='text-end align-items-end d-flex justify-content-end'>{langPreference?.height || "H"}</span></th>
                                    <th className='col-1'><span className='text-end align-items-end d-flex justify-content-end'>{langPreference?.diameter || "D"}</span></th>
                                    <th className='col-1'><span className='text-end align-items-end d-flex justify-content-end'>{langPreference?.qty || "Qty"}</span></th>
                                    <th className='col-1'>{langPreference?.remarks || "Remark"}</th>
                              </tr>
                            </thead>
                            <tbody>
                          <>
                            {details?.seqNo?.map((ele, index1) => <>
                              {ele?.billingItems?.length > 0 &&
                                <> 
                                <tr key={index1} >
                                <td><span>{ele?.boqItem?.sNo ? `${ele?.serialNo}/${ele?.boqItem?.sNo}` : ele?.serialNo}</span></td>
                                <td><span style={{maxWidth:'200px'}}>{getTextBreak(ele?.boqItem?.nameAndDetails || ele?.uniqueItem?.name || ele?.uniqueItem?.localName)}</span></td>
                              </tr>
                                  {ele?.billingItems?.map((item, index) => (
                                    <>
                                    {ele?.billingItems?.filter(el => el?.dprItem?._id == item?.dprItem?._id)?.[0]?._id == item?._id && 
                                        <>
                                          <tr >
                                            <td>{item?.dprItem?.workDescription}</td>
                                            <td><span style={{ maxWidth: '200px' }}>{item?.dprItem?.commodityPart} | {item?.dprItem?.commoditySubPart}</span></td>
                                          </tr>
                                        </>
                                    }
                                    <tr key={index} >
                                      {/* <td><span>{item?.dpr?.createDate && moment(item?.dpr?.createDate).format("DD/MM/YYYY")}</span></td> */}
                                      <td></td>
                                      <td className='text-wrap' style={{ maxWidth: "200px" }}>{item?.subPart}</td>
                                      <td ><span className='text-end align-items-end d-flex justify-content-end'>{item?.number1} </span></td>
                                      <td ><span className='text-end align-items-end d-flex justify-content-end'>{item?.number2} </span></td>
                                      <td ><span className='text-end align-items-end d-flex justify-content-end'>{!item?.isDiameter && item?.length ? Number(item?.length)?.toFixed(2) : "0.00"} </span></td>
                                      <td ><span className='text-end align-items-end d-flex justify-content-end'>{!item?.isDiameter && item?.breath ? Number(item?.breath)?.toFixed(2) : "0.00"} </span></td>
                                      <td ><span className='text-end align-items-end d-flex justify-content-end'>{item?.height ? Number(item?.height)?.toFixed(2) : "0.00"}</span> </td>
                                      <td ><span className='text-end align-items-end d-flex justify-content-end'>{item?.isDiameter && item?.diameter ? Number(item?.diameter)?.toFixed(2) : "0.00"} </span></td>
                                      <td><span className='text-end align-items-end d-flex justify-content-end'>{item?.quantity ? Number(item?.quantity)?.toFixed(2) : "0.00"}</span></td>
                                      <td >{item?.remarks} </td>

                                    </tr>
                                    
                                    </>
                                  ))}
                                <tr  >
                                <td></td>
                                <td><span>{langPreference?.total || "Total"}</span></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><span className='text-end align-items-end d-flex justify-content-end' style={{maxWidth:'200px'}}>{ele?.totalQty}</span></td>
                                <td></td>

                              </tr>
                                </>
                              }
                            </>)}
                          </>
                            </tbody>
                          </table>
                        </div>
                      </div>

                
                     

                 {!isPreview && <ActivityHistory data={details} language={langPreference} />}

                    
                          <div className="d-flex align-items-center justify-contend-start gap-2 mt-3">
                             {isPreview ? <>
                                <button className="m-0 mb-2 mb-sm-2 sbm-purchase" style={{ marginRight: 0 }} onClick={()=>previewBack(previewId)}>{langPreference.back || "Back"}</button>
                             </> : <>
                                {!["approved", "rejected"]?.includes(details?.status) && userDetails?.roleId?.permission.includes("billingUpdate") && <div className="d-flex justify-content-between gap-2">
                                   <div className="btn btn-primary" onClick={() => navigate(`/billing/update/${details?._id}?tab=${searchParams?.get('tab')}`)}>{langPreference.edit || "Edit"}</div>
                                </div>}

                                {details?.status !== "created" && details?.status !== "approved" && details?.status !== "rejected" && userDetails?.roleId?.permission.includes("billingApprove") && <div className="d-flex justify-content-between gap-2">
                                   <div className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => setUpdatedStatus("approved")}>{langPreference.approve || "Approve"}</div>
                                </div>}
                                {["submitted", "approved"].includes(details?.status) && !details?.voucherId && userDetails?.roleId?.permission.includes("billingReject") && <div className="d-flex justify-content-between gap-2">
                                   <div className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => setUpdatedStatus("rejected")}>{langPreference.reject || "Reject"}</div>
                                </div>}
                             </>}
                             {details?.seqNo && <div className="d-flex justify-content-between gap-2">
                                <button className="btn text-white create-order" disabled={download} onClick={() => !download && (previewId || id) && getDownloadDetails(id)}>{langPreference.download || "Download"}</button>
                             </div>}

                             {details?.billType === "subcontractor" && ["created", "submitted", "approved"].includes(details?.status) && <div className="d-flex justify-content-between gap-2">
                                <button className="btn text-white create-order" disabled={sending} onClick={sendToSubcontractor}>
                                   {sending ? (langPreference?.sending || "Sending...") : (langPreference?.send_to_subcontractor || "Send to Subcontractor")}
                                </button>
                             </div>}

                             {details?.billType === "subcontractor" && details?.status === "approved" && userDetails?.roleId?.permission.includes("voucherWrite") && <div className="d-flex justify-content-between gap-2">
                                <button className="btn text-white create-order" onClick={openBillingVoucher}>
                                   {details?.voucherId ? (langPreference?.view_voucher || "View Voucher") : (langPreference?.create_voucher || "Create Voucher")}
                                </button>
                             </div>}

                             {details?.status === "created" && <div>
                                <button type="button" disabled={sumitting} data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => setUpdatedStatus("submitted")} className="mb-2 mb-sm-2 mt-0 sbm-purchase" style={{ marginRight: 0 }} >
                                   {sumitting ? <Spinwheel sizeClass={"spin-small"} /> : langPreference?.submit_for_approval || "Submit for approval"}
                                </button>
                             </div> }


                          </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal modalId={confirmModalId} handleConfirm={handleConfirmation} message={getConfirmationMsg()} />
      <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
      <StatusModal
        modalId={statusModalId}
        message={confirmationMsg}
        handleClose={handleCloseStatusModal}
      />
    </>
  )
}

export default ViewBilling
